<template>
  <div class="UserContainer">
    <div class="header">
      <div class="header-top">
        <img :src="avatar?avatar:'/static/images/avatar.png'" alt="图片未加载">
        <div>
          <span>{{ username }}</span>
          <span>累计贡献：{{ totalScore }}</span>
        </div>
      </div>
    </div>
<!--    <div class="mui-card" >-->
<!--      <div class="mui-item">-->
<!--       <div class="mui-table-view-cell">-->
<!--         <router-link class="mui-navigate-right" to="">-->
<!--           <img src="/static/images/member_user_icon.png" alt="">-->
<!--            <span>个人信息</span>-->
<!--         </router-link>-->
<!--       </div>-->
<!--     </div>-->
<!--    </div>-->
    <div class="mui-card" >
      <div class="mui-item">
        <div class="mui-table-view-cell">
          <router-link class="mui-navigate-right" to="/user/integral">
            <img src="/static/images/member_integral_icon.png" alt="">
            <span>积分详情</span>
          </router-link>
        </div>
      </div>
    </div>
    <div class="mui-card" >
      <div class="mui-item">
        <div class="mui-table-view-cell">
          <router-link class="mui-navigate-right" to="/user/contributionDetail">
            <img src="/static/images/member_contribute_icon.png" alt="">
            <span>上报记录</span>
          </router-link>
        </div>
      </div>
    </div>
<!--    <div class="mui-card" >-->
<!--      <div class="mui-item">-->
<!--        <div class="mui-table-view-cell">-->
<!--          <router-link class="mui-navigate-right" to="/user/group">-->
<!--            <img src="/static/images/member_group_icon.png" alt="">-->
<!--            <span>我的小组</span>-->
<!--          </router-link>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
  </div>
</template>

<script>
export default {
  name: 'UserContainer.vue',
  data () {
    return {
      username: '',
      totalScore: '',
      avatar: '',
      title: '个人中心',
    }
  },
  created () {
    this.getUserInfo(),
    this.$emit('getTitle', this.title)
  },
  methods: {
    getUserInfo () {
      this.$http.post('api/gather/getUserInfo')
        .then(function (data) {
          this.username = data.body.data.list.username
          this.avatar = data.body.data.list.avatar
          this.totalScore = data.body.data.list.score
        })
    }
  }
}
</script>

<style scoped>

  .header{
    background-image: url('/static/images/member_bg.png');
    background-repeat: no-repeat;
    background-size: 100%;
    border-bottom-left-radius: 5%;
    border-bottom-RIGHT-radius: 5%;
    margin-bottom: 5px;
  }

  .header .header-top{
    text-align: center;
    padding-bottom: 10px;
  }

  .header .header-top img{
    width: 25%;
    border-radius: 50%;
    margin-top: 10%;
    margin-bottom: 5%;
  }

  .header .header-top span{
    width: 100%;
    display: block;
    font-size:16px;
    line-height: 20px;
  }

  .header .header-bottom{
    width: 100%;
    height: 40px;
  }

  .header .header-bottom .header-bottom-left{
    width: 45%;
    display: block;
    text-align: left;
    float: left;
    font-size:16px;
    line-height: 20px;
    margin-left: 5%;
  }

  .header .header-bottom .header-bottom-right{
    width: 45%;
    display: block;
    text-align: right;
    float: left;
    font-size:16px;
    line-height: 20px;
    margin-right: 5%;
  }

  .mui-card{
    margin-bottom: 3px;
  }

  .mui-card  .mui-item  .mui-table-view-cell  .mui-navigate-right{
    display: block;
    background-color: white;
  }

  .mui-card  .mui-item  .mui-table-view-cell  .mui-navigate-right span{
    font-size:16px;
    line-height: 40px;
    display: table-cell;
    vertical-align:middle;
    padding-left: 20%;
  }

  .mui-card  .mui-item  .mui-table-view-cell  .mui-navigate-right img{
    width: 12%;
    display: block;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// src/components/tabbar/UserContainer.vue